import React from 'react';
import { logger } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import pathfinder from '@fiverr-private/pathfinder';
import { Stack } from '@fiverr-private/layout_components';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { VacationMessageBanner, UGCTranslateButton } from '@fiverr-private/seller_pages_toolbox';
import { PAGE_NAME } from '../../../../configuration/constants';
import { useSellerRoles } from '../../hooks/useSellerRoles';
import { useUGCData } from '../../hooks/useUGCData';
import { RolePageHeader } from '../RolePageHeader';
import { RolePageRolesTabs } from '../RolePageRolesTabs';
import { RolePageTabContent } from '../RolePageTabContent';

export const MainContent = ({ sidebarThresholdRef }: { sidebarThresholdRef?: React.RefObject<HTMLDivElement> }) => {
    const { locale } = getContext();
    const sellerRoles = useSellerRoles();
    const { onUGCTranslateSuccess, getUgc } = useUGCData();

    const isDefaultLocale = locale === DEFAULT_FIVERR_LOCALE;

    return (
        <ErrorBoundary onError={onRenderError}>
            <Stack direction="column" gap="14" paddingBottom="14">
                <Stack direction="column" gap="8">
                    <div ref={sidebarThresholdRef}>
                        <RolePageHeader />
                    </div>
                    {!isDefaultLocale && (
                        <UGCTranslateButton
                            componentName={PAGE_NAME}
                            sourceName="seller_page"
                            translateURL={pathfinder('seller_page_ugc_translate')}
                            getUgc={getUgc}
                            onSuccess={onUGCTranslateSuccess}
                        />
                    )}
                    <VacationMessageBanner sectionClassName="m-b-0" />
                    {sellerRoles.length ? (
                        <RolePageRolesTabs />
                    ) : (
                        <RolePageTabContent sellerRole={null} hideTitle={true} />
                    )}
                </Stack>
            </Stack>
        </ErrorBoundary>
    );
};

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the MainContent Component');
    logger.error(err, {
        cause: originalError,
    });
};
